import React from 'react';
import { Link } from 'react-router-dom';
import './HomePage.css';

const APPS = [
  {
    path: '/agent-bench',
    icon: '🤖',
    title: 'AgentBench',
    featured: true,
    desc: 'Structured benchmark platform: 15 challenges across 7 categories. Agent performs tasks in real UI, outcomes are auto-verified, scored and graded.',
    tags: ['Auto-Evaluated', '15 Challenges', 'Scored Results', 'Form Filling', 'Data Grid', 'Drag & Drop', 'Navigation', 'Reasoning'],
    color: '#0a0f1e',
    lightColor: '#e8eaf6',
  },
  {
    path: '/shipping',
    icon: '📦',
    title: 'Shipping Management',
    desc: 'Locate vendors by ID, create and submit shipping orders, view order history.',
    tags: ['Vendor Lookup', 'Order Form', 'Data Table', 'Conditional Fields'],
    color: '#1a237e',
    lightColor: '#e8eaf6',
  },
  {
    path: '/eval',
    icon: '🧪',
    title: 'Agent Evaluation Hub',
    desc: 'Full-spectrum test suite for evaluating LLM computer-control and reasoning capabilities.',
    tags: ['CRUD', 'Multi-Step Wizard', 'Data Grid', 'Drag & Drop', 'Conditional Logic', 'Search & Filter', 'Tabs & Notifications'],
    color: '#0d47a1',
    lightColor: '#e3f2fd',
  },
];

const EVAL_SCENARIOS = [
  { icon: '📋', title: 'Task Manager', desc: 'Add, edit, delete tasks. Filter by priority & status. Inline editing with confirmation modals.' },
  { icon: '📝', title: 'Multi-Step Form', desc: '4-step registration wizard with per-step validation, conditional fields, and final review.' },
  { icon: '📊', title: 'Data Grid', desc: 'Sort by multiple columns, filter employees, paginate, select rows, view aggregates.' },
  { icon: '🧮', title: 'Loan Engine', desc: 'Dynamic fields based on employment type & loan type. Multi-factor scoring with reasoning output.' },
  { icon: '🗂', title: 'Tabs & Accordion', desc: 'Nested tabs, FAQ accordion, notification read/dismiss, profile with integrations.' },
  { icon: '🗃', title: 'Kanban Board', desc: 'Drag & drop cards across columns. Add and remove cards. Track board state.' },
  { icon: '🔍', title: 'Product Search', desc: 'Live search, sidebar filters, price range, rating slider, cart & wishlist toggles.' },
];

export default function HomePage() {
  return (
    <div className="home-wrapper">
      <div className="home-hero">
        <div className="home-hero-inner">
          <div className="home-hero-badge">LLM Evaluation Platform</div>
          <h1 className="home-hero-title">CUA EVALS</h1>
          <p className="home-hero-sub">
            A comprehensive React application designed to evaluate LLM computer-control capabilities —
            screen interaction, app navigation, form handling, and complex reasoning.
          </p>
        </div>
      </div>

      <div className="home-body">
        <section className="home-section">
          <h2 className="home-section-heading">Applications</h2>
          <div className="home-apps-grid">
            {APPS.map(app => (
              <Link key={app.path} to={app.path} className="home-app-card" style={{ '--card-color': app.color, '--card-light': app.lightColor }}>
                <div className="home-app-icon" style={{ background: app.lightColor }}>{app.icon}</div>
                <div className="home-app-content">
                  <div className="home-app-title">{app.title}</div>
                  <div className="home-app-desc">{app.desc}</div>
                  <div className="home-app-tags">
                    {app.tags.map(t => <span key={t} className="home-tag">{t}</span>)}
                  </div>
                </div>
                <div className="home-app-arrow">→</div>
              </Link>
            ))}
          </div>
        </section>

        <section className="home-section">
          <h2 className="home-section-heading">Evaluation Scenarios</h2>
          <p className="home-section-sub">Each scenario in the Eval Hub is designed to test a specific agent capability.</p>
          <div className="home-scenarios-grid">
            {EVAL_SCENARIOS.map(s => (
              <div key={s.title} className="home-scenario-card">
                <div className="home-scenario-icon">{s.icon}</div>
                <div className="home-scenario-title">{s.title}</div>
                <div className="home-scenario-desc">{s.desc}</div>
              </div>
            ))}
          </div>
        </section>

        <section className="home-section">
          <h2 className="home-section-heading">Quick Navigation</h2>
          <div className="home-nav-grid">
            <Link to="/agent-bench" className="home-nav-item home-nav-featured">🤖 AgentBench — <span>/agent-bench</span></Link>
            <Link to="/shipping" className="home-nav-item">📦 Shipping App — <span>/shipping</span></Link>
            <Link to="/eval" className="home-nav-item">🧪 Eval Hub — <span>/eval</span></Link>
            <Link to="/eval" className="home-nav-item">📋 Task Manager — <span>/eval → Task Manager</span></Link>
            <Link to="/eval" className="home-nav-item">📝 Multi-Step Form — <span>/eval → Form Wizard</span></Link>
            <Link to="/eval" className="home-nav-item">📊 Data Grid — <span>/eval → Data Grid</span></Link>
          </div>
        </section>
      </div>

      <footer className="home-footer">
        CUA EVALS · Built for LLM Agent Evaluation · React + React Router · {new Date().getFullYear()}
      </footer>
    </div>
  );
}
